/**
 * Safely parses a JSON string and returns the parsed object.
 *
 * @param input - The input string | json
 * @returns The parsed object, or `null` if parsing fails or the input is not a valid JSON string.
 *
 * @example
 * const validJSON = '{"key": "value"}';
 * const parsed = safeParseJSON(validJSON);
 * console.log(parsed); // Output: { key: "value" }
 *
 * const invalidJSON = 'N/A';
 * const parsedInvalid = safeParseJSON(invalidJSON);
 * console.log(parsedInvalid); // Output: null
 *
 * @author Sabin Nițu
 */
export function safeParseJSON(input: any): any {
  // If input is null or undefined, return null
  if (input == null) {
    return null;
  }

  // If input is already an object (but not an array), return it as is
  if (typeof input === 'object' && !Array.isArray(input)) {
    return input;
  }

  // If input is not a string at this point, return null
  if (typeof input !== 'string') {
    // console.warn('Provided input is not a string:', input);
    return null;
  }

  try {
    return JSON.parse(input);
  } catch (error) {
    // console.error('Failed to parse JSON:', error, 'Input:', input);
    return null;
  }
}
